import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./contexts/user-context";
import { PrayerModalProvider } from "./contexts/prayer-modal-context";
import { BurgerMenuProvider } from "./contexts/burger-menu-context";
import { SignUpModalProvider } from "./contexts/signup-modal-context";
import { SignInModalProvider } from "./contexts/signin-modal-context";
import { ForgottenPasswordProvider } from "./contexts/forgotten-password-context";
import { UnregisteredEmailProvider } from "./contexts/unregistered-email-context";
import { GuestSignUpModalProvider } from "./contexts/guest-signup-modal-context";
import { SaveGuestDetailsProvider } from "./contexts/save-guest-details-context";
import { ConfirmDeleteModalProvider } from "./contexts/confirm-delete-modal-context";
import { PrayerIdProvider } from "./contexts/prayer-id-context";
import { ProgressBarProvider } from "./contexts/progress-bar-context";

import App from "./App";

// import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { HidePrayersProvider } from "./contexts/hide-prayers-context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <BurgerMenuProvider>
          <SignInModalProvider>
            <PrayerModalProvider>
              <SignUpModalProvider>
                <ForgottenPasswordProvider>
                  <UnregisteredEmailProvider>
                    <GuestSignUpModalProvider>
                      <SaveGuestDetailsProvider>
                        <ConfirmDeleteModalProvider>
                          <PrayerIdProvider>
                            <ProgressBarProvider>
                              <HidePrayersProvider>
                                <App />
                              </HidePrayersProvider>
                            </ProgressBarProvider>
                          </PrayerIdProvider>
                        </ConfirmDeleteModalProvider>
                      </SaveGuestDetailsProvider>
                    </GuestSignUpModalProvider>
                  </UnregisteredEmailProvider>
                </ForgottenPasswordProvider>
              </SignUpModalProvider>
            </PrayerModalProvider>
          </SignInModalProvider>
        </BurgerMenuProvider>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
